import { get } from "./api"

export const getDiscrepancyReports = (params) => {
  return get("/stock-take/discrepancy-report", params)
}
